"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicFavorite = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicFavorite, _Component);

  var _super = _createSuper(TopicFavorite);

  function TopicFavorite(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicFavorite);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isLoading", false);
    _this.toggleSubscription = _this.toggleSubscription.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isSubscribed: false
    };
    return _this;
  }

  (0, _createClass2.default)(TopicFavorite, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.props.isGuestUser) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _axios.default.get("/subscribers/topic/".concat(this.props.id));

              case 4:
                res = _context.sent;
                this.setState({
                  isSubscribed: res.data.subscribed
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isSubscribed !== this.props.isSubscribed) {
        this.setState({
          isSubscribed: this.props.isSubscribed
        });
      }
    }
  }, {
    key: "toggleSubscription",
    value: function () {
      var _toggleSubscription = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        var newState;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();

                if (!this.isLoading) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this.isLoading = true;
                newState = !this.state.isSubscribed;
                this.setState({
                  isSubscribed: newState
                });
                _context2.prev = 6;
                _context2.next = 9;
                return (0, _axios.default)("/subscribers/topic/".concat(this.props.id), {
                  method: newState ? 'post' : 'delete'
                });

              case 9:
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);
                this.setState({
                  isSubscribed: !newState
                });
                throw _context2.t0;

              case 15:
                _context2.prev = 15;
                this.isLoading = false;
                return _context2.finish(15);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11, 15, 18]]);
      }));

      function toggleSubscription(_x) {
        return _toggleSubscription.apply(this, arguments);
      }

      return toggleSubscription;
    }()
  }, {
    key: "showLoginModal",
    value: function showLoginModal() {
      window.dispatchEvent(new CustomEvent('GuestUserAction'));
    }
  }, {
    key: "render",
    value: function render() {
      var isSubscribed = !!this.state.isSubscribed || Boolean(this.props.isSubscribed);
      if (isSubscribed === undefined) return null;
      return (0, _preact.h)("a", {
        className: "qa-link-subscribe link link--quiet icon--b icon--star post__action-link ".concat(isSubscribed ? 'is-active' : ''),
        onClick: this.props.isGuestUser ? this.showLoginModal : this.toggleSubscription
      }, (0, _preact.h)("span", {
        className: "post__action-link__text"
      }, (0, _preact.h)(_phrase.default, {
        key: isSubscribed ? 'y' : 'n',
        p: isSubscribed ? 'subforum.subscription.unsubscribe' : 'Subscribe'
      })));
    }
  }]);
  return TopicFavorite;
}(_preact.Component);

var _default = TopicFavorite;
exports.default = _default;